import {SectionId, QuestionnaireId, QuestionGroupId} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function updateName(
  questionnaireId: QuestionnaireId,
  sectionId: SectionId,
  questionGroupId: QuestionGroupId,
  name: string,
) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/questionnaires/{questionnaire_id}/sections/{section_id}/question_groups/{question_group_id}/name`,
    {path: {questionnaire_id: questionnaireId, section_id: sectionId, question_group_id: questionGroupId}, body: name},
  );
  await invalidateQueries([q.vendorToolkit.questionnaires.filter()]);
  return res;
}
